<template>
  <div class="bodymain1">
    <el-card class="box-card boxcard" style="min-height: calc(100% - 30px);">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>对账确认</b>
      </div>
      <div class=' contijiao wkbmf loaded' v-if="suprow.ccheck=='已确认'">
        <div class='stamp stamp1'> </div>
      </div>
      <div style="width:100%; height:55px">
        <div class="pull-right" style="margin-bottom: 15px">
          <el-upload action="#" ref="uploadFail" style="display:inline-block;margin:0 10px"
            :disabled="suprow.ccheck=='已确认'" :show-file-list="false" :before-upload="brforeUploadreImportFail"
            :auto-upload="false" :on-change="handleChangeFail" :file-list="fileListFail" :accept="typeaccept">
            <el-button type="success" size="medium" plain
              :disabled="suprow.ccheck=='已确认'">对账单上传({{typeaccept}})</el-button>
          </el-upload>
          <!-- <Debounce :time='300' :isDebounce="1">
            <el-button type="warning" plain @click.native="down()" size="medium">对账单下载</el-button>
          </Debounce> -->
          <Debounce :time='300' :isDebounce="1">
            <el-button type="warning" plain @click.native="GetHTFileUrl()" size="medium">预览</el-button>
          </Debounce>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="PriceSubmit()" size="medium"
              :disabled="suprow.ccheck=='已确认'">确认</el-button>
          </Debounce>
          <el-button type="info" plain size="medium" @click="returnpage('1')">返回主表</el-button>
          <el-button type="info" plain size="medium" @click="returnpage('2')">返回首页</el-button>
        </div>
      </div>
      <table cellpadding="0" cellspacing="0" class="tableaccount">
        <tbody>
          <tr>
            <td width="100">对账单号</td>
            <td width="200">{{informdata.ccode}}</td>
            <td width="100">对账公司</td>
            <td colspan="3">{{informdata.ccorpname}}</td>
            <td width="120">确认截止日期</td>
            <td width="120">{{informdata.dreturndate}}</td>
          </tr>
          <tr>
            <td>预付款</td>
            <td width="160">{{informdata.ipaymentmoney}}</td>
            <td>到货待开票</td>
            <td width="160">{{informdata.izgmoney}}</td>
            <td width="100">应付款</td>
            <td width="160">{{informdata.iapmoney}}</td>
            <td>对账截止日期</td>
            <td>{{informdata.ddate}}</td>
          </tr>
          <tr>
            <td>备注</td>
            <td colspan="7">{{informdata.cremark}}</td>

          </tr>
          <tr>
            <td>确认备注</td>
            <td colspan="7">
              <el-input type="textarea" maxlength="100" :rows="2" v-model="informdata.cvenremark" @input="descinput"
                placeholder="确认备注" v-if="suprow.ccheck!='已确认'"></el-input>
              <span v-else>{{informdata.cvenremark}}</span>
            </td>
          </tr>
          <tr>
            <td>确认日期</td>
            <td>{{informdata.dcheckdate}}</td>
            <td>附件信息</td>
            <td colspan="5">{{informdata.cfilename}}</td>
          </tr>
        </tbody>
      </table>
    </el-card>
  </div>
</template>

<script>
  import { RemovePruchaseToDo, GetFileType } from "../../../../api/home";
  export default {
    data() {
      return {
        informdata: {},
        fileListFail: [],
        suprow: [],
        typeaccept: "",
        previnformdata: {},
      };
    },
    created() {
      if (this.$route.params.rows) {
        this.suprow = this.$route.params.rows;
        sessionStorage.setItem("suprow", JSON.stringify(this.$route.params.rows));
        this.previnformdata = this.$route.params.informdata;
        sessionStorage.setItem(
          "informdata",
          JSON.stringify(this.$route.params.informdata)
        );
      } else {
        this.suprow = JSON.parse(sessionStorage.getItem("suprow"));
        this.previnformdata = JSON.parse(sessionStorage.getItem("informdata"));
      }
      this.GetStatementInfo();
      this.FileType();
    },
    methods: {
      // 获取文件类型
      FileType() {
        GetFileType({ type: "06" }).then((res) => {
          console.log(res);
          if (res.data.Success) {
            this.typeaccept = res.data.Data[0].cfileformat;
          }
        });
      },
      // 判断字数
      descinput() {
        const txtval = this.informdata.cvenremark.length;
        if (txtval == 100) {
          this.$message.error("文本已经100个字啦！！");
          return;
        }
      },
      // 预览
      GetHTFileUrl() {
        if (
          this.informdata.cfilepath != "" &&
          this.informdata.cfilepath != undefined
        ) {
          window.open(this.global.BASE_URL + this.informdata.cfilepath);
        } else {
          this.$message.error("暂无对账单文件！！");
        }
      },
      // 返回
      returnpage(type) {
        sessionStorage.removeItem("params");
        if (type == "1") {
          this.$router.push({
            path: "/AccountStatementList/AccountStatementList",
            query: { informdata: this.previnformdata },
          });
        } else {
          this.$router.push({ path: "/home" });
        }
      },
      GetStatementInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/GetStatementInfo",
          data: { KeyValue: this.suprow.id },
        }).then((res) => {
          console.log(res, "获取信息结果");
          if (res.data.Success) {
            this.informdata = res.data.Data[0];
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
      // 确认
      PriceSubmit() {
        this.$confirm("点击确认之后将无法在上传文件, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/QueryStatement",
              data: {
                KeyValue: this.suprow.id,
                cvenremark: this.informdata.cvenremark,
              },
            }).then((res) => {
              console.log(res, "确认");
              if (res.data.Success) {
                this.$message.success("确认成功！");
                this.removerp();
                this.returnpage("1");
              } else {
                this.$message.error(res.data.Message);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      },
      // 删除待办事项中的信息
      removerp() {
        RemovePruchaseToDo({
          KeyValue: this.suprow.id,
        }).then((res) => {
          console.log(res);
        });
      },
      //上传文件
      handleChangeFail(file, fileList) {
        this.$refs.uploadFail.submit();
      },
      // 上传文件
      brforeUploadreImportFail(file) {
        this.$axios({
          method: "post",
          url: "CommonModule/Op_Supplier/SupplierCheckAll",
          data: { cbilltype: "对账单上传", cbillid: this.suprow.id },
        }).then((res) => {
          console.log(res, "上传结果上传结果上传结果上传结果");

          if (res.data.Success) {
            let varparams = new FormData();
            varparams.append("file", file);
            varparams.append("file", URL.createObjectURL(file));
            varparams.append("cvoucherno", "op_statement");
            varparams.append("ctype", "06");
            varparams.append("cvoucherid", this.suprow.id);
            this.$axios({
              method: "post",
              url: "CommonModule/Op_Supplier/BaseUploadFile",
              headers: { "Content-Type": "multipart/form-data" },
              data: varparams,
              timeout: 30000000,
            }).then((res) => {
              console.log(res, "上传结果");
              if (res.data.Success) {
                this.$message({
                  howClose: true,
                  message: "上传成功",
                  type: "success",
                });
                this.informdata.cfilepath = res.data.Data;
              } else {
                this.$message.error(res.data.Message);
              }
            });

            return false; //屏蔽了action的默认上传
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
    },
  };
</script>
<style scoped>
</style>